import { useGetDetalleAmortizacionActivoById } from "api/Activo.hook"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { tipoPeriodo } from "../../constants/tipoPeriodo"

export const DetalleAmortizacion = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { activoId } = useParams<{ activoId: string }>()
  const { detalleAmortizacionActivo } =
    useGetDetalleAmortizacionActivoById(activoId)

  return (
    <div className='tw-bg-white tw-rounded-lg tw-p-6 tw-w-full tw-shadow-sm'>
      <p className='tw-font-medium tw-mb-auto tw-pb-4'>
        {t("nsAssets.tabAmortizable.amortizationDetails")}
      </p>
      <div className='tw-table tw-w-full tw-text-xs tw-col-span-3 tw-border-b tw-border-neutral-25 tw-pb-4 tw-mb-4 tw-leading-3'>
        <div className='tw-table-header-group tw-uppercase'>
          <div className='tw-table-row'>
            <div className='tw-table-cell'>
              {t("nsAssets.tabAmortizable.amortizationTableConcept")}
            </div>
            <div className='tw-table-cell'>
              {t("nsAssets.tabAmortizable.amortizationPeriod")}
            </div>
            <div className='tw-table-cell'>
              {t("nsAssets.tabAmortizable.coefficient")}
            </div>
            <div className='tw-table-cell'>
              {t("nsAssets.tabAmortizable.years")}
            </div>
          </div>
        </div>
        <div className='tw-table-row-group'>
          <div className='tw-table-row tw-text-base'>
            <div className='tw-table-cell'>
              {detalleAmortizacionActivo?.concepto ?? "-"}
            </div>
            <div className='tw-table-cell'>
              {detalleAmortizacionActivo?.tipoPeriodo
                ? tipoPeriodo(t)[detalleAmortizacionActivo.tipoPeriodo]
                : "-"}
            </div>
            <div className='tw-table-cell'>
              {detalleAmortizacionActivo?.coeficienteAmortizacion
                ? `${detalleAmortizacionActivo?.coeficienteAmortizacion} %`
                : "-"}
            </div>
            <div className='tw-table-cell'>
              {detalleAmortizacionActivo?.anyos ?? "-"}
            </div>
          </div>
        </div>
      </div>
      <div className='tw-text-text-50 tw-uppercase tw-font-medium'>
        <p
          className='tw-text-xs tw-mb-4 tw-cursor-pointer hover:tw-brightness-90'
          onClick={() =>
            history.push(
              `${ROUTES.LIBRO_MAYOR}/${detalleAmortizacionActivo?.cuentaContableAcumulada?.id}`
            )
          }
        >
          <span className='tw-text-text-hyperlinks tw-ml-2 tw-text-base tw-font-normal tw-normal-case'>
            {`${
              detalleAmortizacionActivo?.cuentaContableAcumulada?.numero ??
              "000000"
            } - ${
              detalleAmortizacionActivo?.cuentaContableAcumulada?.nombre ?? ""
            }`}
          </span>
        </p>
        <p
          className='tw-text-xs tw-mb-auto tw-cursor-pointer hover:tw-brightness-90'
          onClick={() =>
            history.push(
              `${ROUTES.LIBRO_MAYOR}/${detalleAmortizacionActivo?.cuentaContableGasto?.id}`
            )
          }
        >
          <span className='tw-text-text-hyperlinks tw-ml-2 tw-text-base tw-font-normal tw-normal-case'>
            {`${
              detalleAmortizacionActivo?.cuentaContableGasto?.numero ?? "000000"
            } - ${
              detalleAmortizacionActivo?.cuentaContableGasto?.nombre ?? ""
            }`}
          </span>
        </p>
      </div>
    </div>
  )
}
